import { Request } from '@/classes/Request'

// POST /ajax/funding_sources/add_bank_account
export const vericheckData = async (payload: Object): Promise<void | string> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post('/ajax/funding_sources/add_bank_account', payload)
      .then(() => {
        resolve()
      })
      .catch(err => {
        reject('Failed to add bank account: ' + err)
      })
  })
}
